import jwtDecode from 'jwt-decode';
export var tokenExpiration = function (token) {
    return token && new Date(jwtDecode(token).exp * 1000);
};
